// extracted by mini-css-extract-plugin
export var active = "_97-7";
export var container = "_97-0";
export var evenWidth = "_97-4";
export var large = "_97-5";
export var outlet = "_97-8";
export var slide = "_97-2";
export var small = "_97-6";
export var tab = "_97-3";
export var tabs = "_97-1";